export function onlyDigits(value?: string | null): string {
  return String(value || "").replace(/\D/g, "");
}

export function isValidCPF(cpf: string): boolean {
  const digits = onlyDigits(cpf);
  if (digits.length !== 11) {
    return false;
  }

  if (/^(\d)\1{10}$/.test(digits)) {
    return false;
  }

  const numbers = digits.split("").map(Number);

  let sum = 0;
  for (let i = 0; i < 9; i += 1) {
    sum += numbers[i] * (10 - i);
  }
  let rest = (sum * 10) % 11;
  if (rest === 10 || rest === 11) {
    rest = 0;
  }
  if (rest !== numbers[9]) {
    return false;
  }

  sum = 0;
  for (let i = 0; i < 10; i += 1) {
    sum += numbers[i] * (11 - i);
  }
  rest = (sum * 10) % 11;
  if (rest === 10 || rest === 11) {
    rest = 0;
  }

  return rest === numbers[10];
}

export function formatCPF(value?: string | null): string {
  const digits = onlyDigits(value);
  if (digits.length !== 11) {
    return value || "";
  }
  return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
}
